const Hero = ({ source, copy }) => {
  return (
    <div className='relative min-h-screen w-full flex flex-col'>
      <video
        autoPlay
        loop
        muted
        playsInline
        className='absolute inset-0 z-0 w-full h-full object-cover'
      >
        <source
          src={source}
          type='video/mp4'
        />
      </video>

      <div className='absolute inset-0 bg-black bg-opacity-70 z-10' />

      <div className='relative z-20 w-full max-w-6xl mx-auto px-4 sm:px-6 flex flex-col min-h-screen'>
        <div className='pt-8 sm:pt-12'>
          <h1
            className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-text-main text-center'
            style={{ fontFamily: "'Teko', sans-serif" }}
          >
            <span className='text-accent'>The</span>Champs
          </h1>
        </div>

        <div className='mt-auto mb-8 sm:mb-12 flex flex-col items-start'>
          <div className='p-1 max-w-[300px] md:max-w-xl text-left mb-2 sm:mb-8'>
            <h2 className='text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 uppercase flex flex-col gap-[2px]'>
              {copy.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </h2>
          </div>

          <button
            className='w-auto sm:w-auto bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-6 sm:px-8 rounded-full text-base sm:text-lg transition-all duration-300 transform hover:scale-105 mb-8 sm:mb-12'
            onClick={() => (window.location.href = 'https://thechamps.app')}
          >
            Start Now
          </button>

          <div className='flex justify-between text-white w-full max-w-lg sm:max-w-2xl md:max-w-4xl lg:max-w-6xl'>
            <div className='text-center'>
              <p className='text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-1 sm:mb-2 text-yellow-500'>
                1.5M+
              </p>
              <p className='text-base sm:text-lg md:text-xl lg:text-2xl'>
                Total Community
              </p>
            </div>
            <div className='text-center'>
              <p className='text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-1 sm:mb-2 text-yellow-500'>
                4.9/5
              </p>
              <p className='text-base sm:text-lg md:text-xl lg:text-2xl'>
                Average Rating
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
